module.exports = __webpack_public_path__ + "img/products_big_can_ice.1bc58d7c.png";